import { lerSessao } from '../auth/sessao';
import { env } from '../env';
import type { Pagina } from '../env/schema';
import { redirectToOldSite } from './old-site';

interface EnabledPageGuardOptions {
  /** Se não informado, o redirect irá para a página informada na checagem */
  redirectToOldSitePage?: string;
}

export async function enabledPageGuard(
  page: Pagina,
  { redirectToOldSitePage }: EnabledPageGuardOptions = {},
) {
  if (isPageEnabled(page)) {
    return;
  }

  await redirectToOldSite(redirectToOldSitePage ?? page, { replace: true });
}

export function isPageEnabled(page: Pagina) {
  const regra = env.VITE_PAGINAS[page];

  if (!regra) {
    return false;
  }

  if (regra === true) {
    return true;
  }

  // Leitura do cache: nas rotas autenticadas o guard já resolveu a sessão.
  const usuario = lerSessao();

  if (!usuario) {
    return false;
  }

  const revendas = regra.revendas ?? [];
  const emails = regra.emails?.map(email => email.toLowerCase()) ?? [];

  return (
    revendas.includes(usuario.revendaId) ||
    emails.some(email => email === usuario.email.toLowerCase())
  );
}
